import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#007bbb] via-[#006399] to-[#007bbb] text-white mt-20 relative overflow-hidden">
      {/* Background Text */}
      <div className="absolute bottom-0 left-0 right-0 text-[180px] font-black text-white/5 text-center leading-none pointer-events-none">
        OKAYAMA
      </div>

      <div className="relative z-10 px-8 lg:px-20 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Column 1: Clinic Info */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-bold mb-6">おかやま整形外科</h3>
            <div className="space-y-3 text-white/80">
              <p className="leading-relaxed">
                〒700-0000<br />
                岡山市北区○○町1-2-3
              </p>
              <p>
                <strong className="text-white">TEL:</strong> 086-012-3456<br />
                <strong className="text-white">FAX:</strong> 086-012-3457
              </p>
            </div>
          </div>

          {/* Column 2: Sitemap */}
          <div>
            <h4 className="text-lg font-semibold mb-6">サイトマップ</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors">
                  トップ
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-white transition-colors">
                  当院について
                </Link>
              </li>
              <li>
                <Link to="/doctor" className="text-white/80 hover:text-white transition-colors">
                  院長紹介
                </Link>
              </li>
              <li>
                <Link to="/access" className="text-white/80 hover:text-white transition-colors">
                  アクセス
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-white/80 hover:text-white transition-colors">
                  お知らせ
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-6">診療時間</h4>
            <div className="text-white/80 space-y-2">
              <p>月〜土曜日</p>
              <p className="text-xl font-semibold text-white">9:00 - 18:00</p>
              <p className="mt-4">
                <span className="inline-block bg-[#006399] px-3 py-1 rounded-lg text-sm">
                  完全予約制
                </span>
              </p>
              <p className="text-sm mt-3">定休日: 日曜日・祝日</p>
            </div>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">お問い合わせ</h4>
            <p className="text-white/80 mb-4 text-sm leading-relaxed">
              ご予約・ご相談は<br />お気軽にお電話ください
            </p>
            <a
              href="tel:086-012-3456"
              className="inline-block bg-white text-[#007bbb] px-6 py-3 rounded-full font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              電話する
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-white/70 text-sm">
            &copy; 2025 おかやま整形外科. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="nofollow noopener noreferrer"
            className="text-white/70 text-sm hover:text-white transition-colors"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
